import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { SavedSearchState } from '@core/models/saved-search.state';
import { MockDataService } from '@core/services/mock-data.service';

import { mockResponse } from '../mock-response';
import { CreateSavedSearchRequest, SavedSearchRepository } from './saved-search.repository';
import { seedSavedSearches } from './saved-search.seed';

const COLLECTION = 'saved-searches';

@Injectable()
export class SavedSearchMockRepository implements SavedSearchRepository {
  private readonly searches = inject(MockDataService).collection<SavedSearchState>(COLLECTION, seedSavedSearches);

  list(shopperId: number): Observable<SavedSearchState[]> {
    return mockResponse(this.searches.list().filter(s => s.shopperId === shopperId));
  }

  create(shopperId: number, request: CreateSavedSearchRequest): Observable<SavedSearchState> {
    const created: SavedSearchState = {
      id: this.searches.allocateId(),
      shopperId,
      title: request.title,
      criteriaLabel: this.describeCriteria(request),
      query: {
        q: request.q,
        categorySlug: request.categorySlug,
        conditionMin: request.conditionMin,
        maxDistanceMi: request.maxDistanceMi
      },
      alertChannel: request.alertChannel,
      newMatchCount: 0,
      icon: request.icon,
      createdAt: new Date()
    };
    return mockResponse(this.searches.upsert(created));
  }

  remove(shopperId: number, id: number): Observable<void> {
    const entry = this.searches.get(id);
    if (entry && entry.shopperId === shopperId) this.searches.remove(id);
    return mockResponse(undefined);
  }

  markRun(shopperId: number, id: number): Observable<SavedSearchState | null> {
    const entry = this.searches.get(id);
    if (!entry || entry.shopperId !== shopperId) return mockResponse(null);
    return mockResponse(this.searches.upsert({ ...entry, newMatchCount: 0 }));
  }

  private describeCriteria(request: CreateSavedSearchRequest): string {
    const condition = request.conditionMin ? 'Excellent or better' : 'Any condition';
    const distance = request.maxDistanceMi ? `within ${request.maxDistanceMi} mi` : 'any distance';
    return `${condition} · ${distance}`;
  }
}
